import React, { useEffect, useState } from 'react';
import ListaAdmin from '../shared/ListaAdmin';

function ListaProdutos() {
  return <ListaAdmin tipo="produto" />;
}

export default ListaProdutos;
